module.exports = __webpack_public_path__ + "img/galeria-ingenieros-1.679c04d6.jpg";